module.exports = __webpack_public_path__ + "static/media/QRcode5.527f5940.png";